var _path, _g, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgGl = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M0 85.34h512v341.326H0z"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#f0f0f0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M512 85.334v166.69L0 256.175V85.334z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 204.054,
  cy: 256.003,
  r: 81.619
}))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M122.435 256.003c0-45.078 36.545-81.623 81.623-81.623 45.079 0 81.623 36.545 81.623 81.623",
  fill: "#d80027"
})));

export default SvgGl;